import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  // Always solid background on non-home pages
  const isHomePage = location.pathname === '/';
  const shouldBeSolid = isScrolled || !isHomePage;
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Discover PlaneSmart',
    path: '/discover'
  }, {
    name: 'Fly With Us',
    path: '/fly-with-us'
  }, {
    name: 'Owner Services',
    path: '/owner-services'
  }, {
    name: 'Training',
    path: '/training'
  }, {
    name: 'Brokerage',
    path: '/brokerage'
  }, {
    name: 'Empty Legs',
    path: '/empty-legs'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${shouldBeSolid ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent pt-10 pb-5'}`} data-id="element-149">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-150">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer group" aria-label="PlaneSmart home" data-id="element-151">
          <img src="https://cdn.magicpatterns.com/uploads/94HkoSwW7cGF2C7tNPrpQP/newplamw-e1769801367696.webp" alt="PlaneSmart" className={`w-auto object-contain transition-all duration-300 ${shouldBeSolid ? 'h-11' : 'h-24'}`} data-id="element-152" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-153">
          {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-brand-500 ${shouldBeSolid ? 'text-charcoal-700' : 'text-white/90'}`} data-id="element-154">
              {link.name}
            </Link>)}
        </nav>

        {/* Actions */}
        <div className="hidden lg:flex items-center gap-6" data-id="element-155">
          <div className={`flex flex-col items-end ${shouldBeSolid ? 'text-charcoal-900' : 'text-white'}`} data-id="element-156">
            <a href="tel:1-888-228-4283" className="flex items-center gap-2 font-medium hover:text-brand-500 transition-colors" data-id="element-157">
              <Phone className="w-4 h-4" data-id="element-158" />
              1-888-2AVIATE
            </a>
          </div>
          <Link to="/contact" className="bg-brand-600 hover:bg-brand-700 text-white px-6 py-2.5 rounded-full text-sm font-medium transition-all shadow-lg shadow-brand-900/20" data-id="element-159">
            Contact Us
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button className={`lg:hidden p-2 ${shouldBeSolid ? 'text-charcoal-900' : 'text-white'}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-160">
          {mobileMenuOpen ? <X data-id="element-161" /> : <Menu data-id="element-162" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-163">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-white shadow-xl border-t border-gray-100 lg:hidden" data-id="element-164">
            <div className="flex flex-col px-6 py-4 gap-4" data-id="element-165">
              {navLinks.map(link => <Link key={link.name} to={link.path} onClick={() => setMobileMenuOpen(false)} className="text-charcoal-800 font-medium py-2 border-b border-gray-50" data-id="element-166">
                  {link.name}
                </Link>)}
              <a href="tel:1-888-228-4283" className="flex items-center gap-2 text-brand-700 font-medium py-2" data-id="element-167">
                <Phone className="w-4 h-4" data-id="element-168" />
                1-888-228-4283
              </a>
              <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="bg-brand-600 text-white px-6 py-3 rounded-lg text-sm font-medium mt-2 text-center" data-id="element-169">
                Contact Us
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}